import React from "react";
import formations, { formationTemplates } from "../formations";
import { getTeamColors } from "components/colors";
import type { MatchStatus } from "service";

interface PlayerFormationProps {
  homeFormation: string;
  awayFormation: string;
  status: MatchStatus;
}

const PlayerFormation: React.FC<PlayerFormationProps> = ({
  homeFormation,
  awayFormation,
  status,
}) => {
  const { home, away } = getTeamColors(status as any);
  const getPlayerRole = (formation: string, number: number): string => {
    const template =
      formationTemplates[formation as keyof typeof formationTemplates];
    if (!template) return "";
    const roleEntry = Object.entries(template).find(
      ([num]) => parseInt(num) === number
    );
    return roleEntry ? (roleEntry[1] as string) : "";
  };

  return (
    <>
      {formations[homeFormation].home.map((player, index) => (
        <div
          key={`home-${index}`}
          className="absolute flex -translate-x-1/2 -translate-y-1/2 flex-col items-center"
          style={{ left: `${player.x}%`, top: `${player.y}%` }}
        >
          <div
            className="flex h-[4vw] w-[4vw] items-center justify-center rounded-full text-[3vw] font-bold text-white"
            style={{
              backgroundColor: home,
              textShadow: "0 0 2px #000, 0 1px 3px #000, 0 2px 6px #000",
              WebkitTextStroke: "2px #000",
              paintOrder: "stroke fill",
            }}
          >
            {player.number}
          </div>
          <div className="mt-[0.5vw] rounded border border-white/20 bg-white/70 px-[0.3vw] py-[0.1vw] text-[2vw] font-semibold text-black">
            {getPlayerRole(homeFormation, player.number)}
          </div>
        </div>
      ))}
      {formations[awayFormation].away.map((player, index) => (
        <div
          key={`away-${index}`}
          className="absolute flex -translate-x-1/2 -translate-y-1/2 flex-col items-center"
          style={{ left: `${player.x}%`, top: `${player.y}%` }}
        >
          <div
            className="flex h-[4vw] w-[4vw] items-center justify-center rounded-full text-[3vw] font-bold text-white"
            style={{
              backgroundColor: away,
              textShadow: "0 0 2px #000, 0 1px 3px #000, 0 2px 6px #000",
              WebkitTextStroke: "2px #000",
              paintOrder: "stroke fill",
            }}
          >
            {player.number}
          </div>
          <div className="mt-[0.5vw] rounded border border-white/20 bg-white/70 px-[0.3vw] py-[0.1vw] text-[2vw] font-semibold text-black">
            {getPlayerRole(awayFormation, player.number)}
          </div>
        </div>
      ))}
    </>
  );
};

export default PlayerFormation;
